import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";

// Website Pages
import WebsiteLayout from "./layouts/WebsiteLayout";
import HomePage from "./pages/website/HomePage";
import AboutPage from "./pages/website/AboutPage";
import ProductsPage from "./pages/website/ProductsPage";
import ServicesPage from "./pages/website/ServicesPage";
import ContactPage from "./pages/website/ContactPage";

function App() {
  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Main Website Routes */}
            <Route element={<WebsiteLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </CartProvider>
  );
}

export default App;
